/**
 * Constants definition.
 *
 * @type {{BLANCO: string, MULATO: string, NEGRO: string}}
 */
const SKIN_COLOR = {
  BLANCO: 'BLANCO',
  MULATO: 'MULATO',
  NEGRO: 'NEGRO',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const SKIN_COLOR_ENUM = Object.keys(SKIN_COLOR);

const BLANCO = SKIN_COLOR_ENUM[0];
const MULATO = SKIN_COLOR_ENUM[1];
const NEGRO = SKIN_COLOR_ENUM[2];

export {
  BLANCO,
  MULATO,
  NEGRO,
  SKIN_COLOR_ENUM,
  SKIN_COLOR,
};
